import React from "react";
import { IconBaseProps as baseProps, IconBase } from "react-icons";
export type IconBaseProps = baseProps;

export type IconFunctionalComponent = React.FC<IconBaseProps>;

// Follows the pattern from gorangajic except no defaults
// Code from https://github.com/gorangajic/react-icon-base/blob/master/index.js
/* NOTE: SS, let me know whether or not you agree with this approach, then I'll delete this note. 

  gorangajic's extracted class is out of date with react-icons
  and doesn't work with react-icons.IconContext.

  This port to Typescript has no dependencies on react-icon-base. It does
  use react-icons.IconBaseProps to ensure forward compatibility. I've removed
  react-icon-base from this package.

  Currently, we don't use this class in our code; we use the one below
  which is a pure react-icons derivative. I've put this here in case there's
  some nuances of gorangajic's code we rely on. If not, we can rip this 
  Component out.


  */
export const BaseIcon: React.FC<IconBaseProps> = ({
  children,
  color,
  size,
  style = {},
  width,
  height,
  ...props
}) => {
  const computedSize = size || "1em";
  const styleProp = { verticalAlign: "middle", ...style };
  if (color) styleProp.color = color;
  return (
    <svg
      children={children}
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      height={height || computedSize}
      width={width || computedSize}
      //       {...reactIconBase}
      {...props}
      style={styleProp}
    />
  );
};

// Follows the actual pattern used in react-icons.
// This should work with react-icons.IconContext, but hasn't been tested.
// The funny signature is because react-icons goes through some work to
// turn popular SVG icon libraries into strongly typed React components.
export const Icon: React.FC<IconBaseProps> = props => {
  return <IconBase attr={{}} {...props} />;
};
